import { render, staticRenderFns } from "./select-menu.vue?vue&type=template&id=56da8c31&scoped=true&"
import script from "./select-menu.vue?vue&type=script&lang=js&"
export * from "./select-menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56da8c31",
  null
  
)

export default component.exports